import { isParseableError } from '@nx/errors';

import { type ExploreError, UnknownErrors, isQueryAborted } from '../errors/errors';

export const errorMapper = (error: unknown): ExploreError => {
  if (!isParseableError(error)) {
    return UnknownErrors.UnknownError;
  }

  if (isQueryAborted(error)) {
    return {
      ...error,
      ignore: true,
    };
  }

  return error;
};
